import { css } from '@emotion/react'
import React from 'react'
import { UnitNumber } from '@/lib/number'
import { font } from 'plume-ui'

export const OverviewAmountWithCurrency: React.VFC<{
  amount: UnitNumber | null
  currency: string
}> = (props) => {
  return (
    <div
      className="values"
      css={css`
        display: flex;
        align-items: center;
      `}
    >
      {props.amount ? (
        <div
          css={css`
            display: flex;
            align-items: center;
            flex-direction: row;
          `}
        >
          <div
            className="currency"
            css={css`
              display: inline-block;
              font-style: normal;
              font-weight: ${font.weight.normal};
              font-size: 13px;
              margin-right: 4px;
            `}
          >
            {props.currency}
          </div>
          <div
            className="value"
            css={css`
              font-style: normal;
              font-weight: ${font.weight.normal};
              font-size: 20px;
            `}
          >
            {props.amount.value.toFixed(1)}
          </div>
          <div
            className="unit"
            css={css`
              display: inline-block;
              font-style: normal;
              font-weight: ${font.weight.normal};
              font-size: 13px;
              margin-left: 4px;
              vertical-align: bottom;
            `}
          >
            {props.amount.unit}
          </div>
        </div>
      ) : (
        <div
          className="value"
          css={css`
            font-style: normal;
            font-weight: ${font.weight.normal};
            font-size: 20px;
            padding-right: 80px;
          `}
        >
          -
        </div>
      )}
    </div>
  )
}
